/* ================================================================
   COLOR-CAROUSEL-1 (rev7) — Tee/CE PDP color -> gallery sync
   ================================================================

   Bug rev6: Step 2 actualitzava la figura amb classe is-active,
   però a mòbil la figura SEMPRE visiblement mostrada és figures[0]
   (la primera del DOM) independentment del toggle CSS off-screen.
   Després del primer swap, is-active passava a figures[1], de manera
   que els swaps posteriors actualitzaven figures[1] (no visiblement
   mostrada a mòbil) i l'usuari veia figures[0] sense canviar.

   Solució rev7:
   - Sempre actualitzem figures[0].img.src al color target
     (el que mòbil mostra visualment sempre).
   - També actualitzem targetFig.img.src (per desktop i CSS correcte).
   - Pre-carrega totes les imatges amagades en boot (evita blancs).
   - Sense cap scroll de pàgina.

   REVERT: copiar REVERT_pdp-color-carousel-rev3.js a
   assets/pdp-color-carousel.js i fer push al MAIN.
   ================================================================ */

(function () {
  'use strict';

  function norm(v) { return v == null ? '' : String(v).trim(); }

  function sectionRootOf(el) {
    return (el.closest && (
      el.closest('[data-section-id]') ||
      el.closest('.pdp') ||
      el.closest('.pdp-main')
    )) || document;
  }

  function scrollThumbIntoView(thumb) {
    var strip = thumb.closest('.pdp-gallery__thumbs');
    if (!strip) return;
    var target = thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2;
    if (typeof strip.scrollTo === 'function') {
      strip.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    } else {
      strip.scrollLeft = Math.max(0, target);
    }
  }

  // Mapa de src originals (boot-time). Mai es corrompen per swaps successius.
  function ensureMediaMap(main) {
    if (main.__heMediaMap) return main.__heMediaMap;
    var map = {};
    [].forEach.call(
      main.querySelectorAll('.pdp-gallery__media'),
      function (fig) {
        var mid = norm(fig.getAttribute('data-media-id'));
        var img = fig.querySelector('.pdp-gallery__media-img, img');
        if (mid && img) {
          map[mid] = {
            src:    img.getAttribute('src')    || '',
            srcset: img.getAttribute('srcset') || '',
            alt:    img.getAttribute('alt')    || ''
          };
        }
      }
    );
    main.__heMediaMap = map;
    return map;
  }

  function applyImgData(img, data) {
    if (!img || !data || !data.src) return;
    img.setAttribute('src', data.src);
    if (data.srcset) img.setAttribute('srcset', data.srcset);
    else img.removeAttribute('srcset');
    if (data.alt) img.setAttribute('alt', data.alt);
  }

  // Pre-carrega les imatges amagades perquè els swaps siguin immediats.
  // Evita el blanc (lazy-load delay) quan una figura amagada es fa activa.
  function preloadGalleryImages() {
    var figs = document.querySelectorAll(
      '[data-pdp-gallery-fallback] .pdp-gallery__media');
    [].forEach.call(figs, function (fig) {
      if (fig.classList.contains('is-active')) return;
      var img = fig.querySelector('.pdp-gallery__media-img, img');
      if (!img || img.__hePreloaded) return;
      img.__hePreloaded = true;
      img.setAttribute('loading', 'eager');
      var src = img.getAttribute('src');
      if (src) {
        var p = new Image();
        p.decoding = 'async';
        var ss = img.getAttribute('srcset');
        if (ss) p.srcset = ss;
        p.src = src;
      }
    });
  }

  function swapFallbackGallery(root, mediaId) {
    var main = root.querySelector('[data-pdp-gallery-fallback]');
    if (!main) return false;

    var figures = Array.prototype.slice.call(
      main.querySelectorAll('.pdp-gallery__media'));
    if (!figures.length) return false;

    var targetIndex = -1;
    for (var i = 0; i < figures.length; i++) {
      if (norm(figures[i].getAttribute('data-media-id')) === mediaId) {
        targetIndex = i;
        break;
      }
    }
    if (targetIndex < 0) return false;
    if (figures[targetIndex].classList.contains('is-active')) return true;

    var mediaMap   = ensureMediaMap(main);
    var targetData = mediaMap[mediaId];
    if (!targetData || !targetData.src) return false;

    var targetFig = figures[targetIndex];
    var targetImg = targetFig.querySelector('.pdp-gallery__media-img, img');

    // 1. Restaura el src original al target (desfa corrupcions anteriors).
    applyImgData(targetImg, targetData);

    // 2. Sempre actualitza figures[0].img — a mòbil sempre es mostra
    //    visualment la primera figura del DOM, independentment del toggle
    //    CSS is-active/hidden quan la galeria està off-screen.
    var firstImg = figures[0]
      ? figures[0].querySelector('.pdp-gallery__media-img, img')
      : null;
    if (firstImg && firstImg !== targetImg) {
      applyImgData(firstImg, targetData);
    }

    // 3. Toggle de figures (mecanisme principal — fiable a desktop;
    //    la còpia als passos 1+2 cobreix mòbil off-screen).
    figures.forEach(function (fig, i) {
      var active = i === targetIndex;
      fig.classList.toggle('is-active', active);
      if (active) { fig.removeAttribute('hidden'); }
      else        { fig.setAttribute('hidden', ''); }
    });

    // 4. Actualitza els thumbs (scroll horitzontal, mai vertical).
    var thumbs = Array.prototype.slice.call(
      root.querySelectorAll(
        '[data-pdp-gallery-fallback-thumbs] [data-pdp-gallery-thumb]'));
    thumbs.forEach(function (t, i) {
      var active = i === targetIndex;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-current', active ? 'true' : 'false');
      if (active) scrollThumbIntoView(t);
    });

    // 5. Actualitza el comptador.
    var counter = root.querySelector('[data-pdp-gallery-counter-current]');
    if (counter) counter.textContent = String(targetIndex + 1);

    return true;
  }

  function clickMatchingThumb(root, mediaId) {
    var thumbs = root.querySelectorAll(
      '[data-pdp-gallery-thumb][data-media-id]');
    for (var i = 0; i < thumbs.length; i++) {
      if (norm(thumbs[i].getAttribute('data-media-id')) === mediaId) {
        if (!thumbs[i].classList.contains('is-active')) {
          try { thumbs[i].click(); } catch (_e) {}
        }
        return true;
      }
    }
    return false;
  }

  function syncGalleryToSwatch(swatch) {
    var mediaId = norm(swatch.getAttribute('data-media-id'));
    if (!mediaId) return;
    var root = sectionRootOf(swatch);
    if (swapFallbackGallery(root, mediaId)) return;
    clickMatchingThumb(root, mediaId);
  }

  function onDocumentClick(e) {
    var swatch = e.target && e.target.closest &&
                 e.target.closest('[data-pdp-swatch]');
    if (!swatch) return;
    if (!swatch.hasAttribute('data-media-id')) return;
    syncGalleryToSwatch(swatch);
  }

  function boot() {
    if (document.documentElement.hasAttribute(
          'data-pdp-color-carousel-bound')) return;
    document.documentElement.setAttribute(
      'data-pdp-color-carousel-bound', 'true');
    document.addEventListener('click', onDocumentClick, true);
    // Pre-carrega imatges amagades per evitar lazy-load delay en swaps.
    preloadGalleryImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
